const SIDENAV_STATE = 'sideNavExpanded';

export const getSideNavState = () => {
    const sideNavStorageState = localStorage.getItem(SIDENAV_STATE);
    return sideNavStorageState ? JSON.parse(sideNavStorageState) : false;
};

export const setSideNavState = (sideNavState) => {
    localStorage.setItem(SIDENAV_STATE, JSON.stringify(!!sideNavState));
};

export const clearSideNavState = () => {
    localStorage.removeItem(SIDENAV_STATE);
};
